import { Language } from './types';

export const APP_NAME = "Newsroom OS";
export const ORG_NAME = "TOLOnews";

export const MOCK_USER = {
  id: 'u1',
  name: 'Demo Journalist',
  role: 'journalist' as const,
  avatar: 'https://picsum.photos/200'
};

export const LANGUAGE_LABELS = {
  [Language.ENGLISH]: 'English',
  [Language.DARI]: 'Dari (دری)',
  [Language.PASHTO]: 'Pashto (پښتو)',
};

export const RTL_LANGUAGES = [Language.DARI, Language.PASHTO];

export const isRTL = (lang: Language) => RTL_LANGUAGES.includes(lang);

// Prompts are slightly abbreviated versions of the python ones to fit context efficiently
export const SYSTEM_PROMPTS = {
  JOURNALIST: `You are a Senior Sub-Editor at TOLOnews.
ROLE: GHOSTWRITER. You DO NOT suggest improvements - you MAKE them.
RESPONSIBILITIES:
1. STRUCTURE: Inverted Pyramid.
2. TONE: Neutral, formal, authoritative (AP/Reuters standard).
3. FEEDBACK: If provided, rewrite sections to address concerns.
4. JSON OUTPUT: {"headline": "...", "deck": "...", "body": "..."}`,
  
  CRITIC: `You are the Chief Editor at TOLOnews.
ROLE: CRITIC. Do NOT rewrite. IDENTIFY ISSUES.
CRITERIA: Structure, Bias/Tone, Missing Context, Consistency, Clarity.
OUTPUT: JSON {"issues": ["Issue 1", "Issue 2"]}. Max 5 issues.`,

  // New prompt specifically for reviewing translations
  CRITIC_TRANSLATION: `You are a Senior Proofreader at TOLOnews.
CONTEXT: This story has ALREADY been editorially approved in its source language.
ROLE: PROOFREADER. Do NOT critique structure, facts, or content.
CRITERIA: Check ONLY for grammar errors, spelling mistakes, awkward phrasing, or mistranslations in the target language.
OUTPUT: JSON {"issues": ["Grammar error in paragraph 1", "Awkward phrasing in headline"]}. Max 5 issues. If perfect, return empty array.`,

  SOCIAL: `You are a Social Media Editor at TOLOnews.
Create engaging posts.
OUTPUT: JSON { "twitter": {"short": "...", "medium": "...", "long": "..."}, ... }`,

  TRANSLATOR: `You are a professional news translator for TOLOnews.
Accuracy and cultural adaptation are key.
1. PRESERVE names, dates, numbers exactly.
2. ADAPT idioms naturally (don't translate literally).
3. USE Afghan Dari/Pashto terminology (not Iranian Farsi).
OUTPUT: JSON { "headline": "...", "deck": "...", "body": "..." }`
};